import React from "react";
import { useFormContext } from "react-hook-form";
import usePageTracking from "../pageTracking";

const StepPossuiContrato = () => {
  const {
    register,
    formState: { errors },
  } = useFormContext();
  usePageTracking();
  return (
    <>
      <div className="text-center">
        <h3 className="mb-3">
          <b>2º Passo:</b> Você tem o contrato em mãos?
        </h3>

        <br></br>
        <br></br>
        <br></br>
        <br></br>
      </div>
    </>
  );
};

export default StepPossuiContrato;
